import { render } from "./ProduitEnvoisExpressPage.vue?vue&type=template&id=8ddd72f0"
import script from "./ProduitEnvoisExpressPage.vue?vue&type=script&lang=js"
export * from "./ProduitEnvoisExpressPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__